<template>
    <div>Смета по станциям</div>
</template>

<script>
export default  {
    name: 'station-estimates-view'
}
</script>